// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"a184d018","453":"11986714","455":"01f3b508","665":"06dbf24b","704":"9c988f1d","977":"939704b2"}[chunkId] + ".chunk.js";
};